import React, {Component} from 'react';

class Testimonial extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 0,
        };

        this.goToPrev = this.goToPrev.bind(this);
        this.goToNext = this.goToNext.bind(this);
        this.setActivePage = this.setActivePage.bind(this);
        this.startAutoplay = this.startAutoplay.bind(this);
        this.stopAutoplay = this.stopAutoplay.bind(this);
    }

    componentDidMount() {
        this.startAutoplay();
    }

    componentDidUpdate(prevProps) {
        const prevPages = this.getReviewPages(prevProps.banner);
        const nextPages = this.getReviewPages(this.props.banner);

        if (prevPages.length !== nextPages.length) {
            this.stopAutoplay();
            this.setState((prevState) => ({
                activePage: nextPages.length === 0 ? 0 : Math.min(prevState.activePage, nextPages.length - 1),
            }), this.startAutoplay);
        }
    }

    componentWillUnmount() {
        this.stopAutoplay();
    }

    getReviewImages() {
        return [
            '/assets/img/customer/customer_1.png',
            '/assets/img/customer/customer_2.png',
            '/assets/img/customer/customer_3.png',
        ];
    }

    normalizeItems(bannerItems) {
        if (Array.isArray(bannerItems)) {
            return bannerItems.filter(Boolean);
        }

        if (bannerItems && Array.isArray(bannerItems.component_items)) {
            return bannerItems.component_items.filter(Boolean);
        }

        return [];
    }

    hashString(value) {
        const text = String(value || '');
        let hash = 0;

        for (let index = 0; index < text.length; index += 1) {
            hash = (hash * 31 + text.charCodeAt(index)) >>> 0;
        }

        return hash;
    }

    getReviews(bannerItems) {
        const items = this.normalizeItems(bannerItems);
        const images = this.getReviewImages();

        return items
            .filter((item) => (item.image_title || '').trim() !== '')
            .map((item, index) => {
                const id = `${item.link_url || item.image_title || item.reviewer_name || 'review'}-${index}`;
                const title = (item.image_title || item.reviewer_name || '').trim();
                const name = title;
                const role = item.image_designation;
                const text = item.image_description;
                const imageIndex = (this.hashString(id) + index) % images.length;

                return {
                    id,
                    name,
                    role,
                    text,
                    avatar: images[imageIndex],
                    rating: Number(item.rating || item.review_rating || 5) || 5,
                };
            })
            .filter((review) => (review.name || '').trim() !== '');
    }

    getReviewPages(bannerItems) {
        const reviews = this.getReviews(bannerItems);
        const pages = [];

        for (let index = 0; index < reviews.length; index += 3) {
            pages.push(reviews.slice(index, index + 3));
        }

        return pages;
    }

    startAutoplay() {
        this.stopAutoplay();

        const pages = this.getReviewPages(this.props.banner);
        if (pages.length <= 1) {
            return;
        }

        this.autoplayTimer = setInterval(() => {
            this.setState((prevState) => ({
                activePage: (prevState.activePage + 1) % pages.length,
            }));
        }, 5200);
    }

    stopAutoplay() {
        if (this.autoplayTimer) {
            clearInterval(this.autoplayTimer);
            this.autoplayTimer = null;
        }
    }

    goToPrev() {
        const pages = this.getReviewPages(this.props.banner);
        if (pages.length === 0) {
            return;
        }

        this.setState((prevState) => ({
            activePage: (prevState.activePage - 1 + pages.length) % pages.length,
        }));
    }

    goToNext() {
        const pages = this.getReviewPages(this.props.banner);
        if (pages.length === 0) {
            return;
        }

        this.setState((prevState) => ({
            activePage: (prevState.activePage + 1) % pages.length,
        }));
    }

    setActivePage(activePage) {
        this.setState({activePage});
    }

    renderStars(rating) {
        const filled = Math.max(0, Math.min(5, Math.round(Number(rating) || 5)));

        return Array.from({length: 5}).map((_, index) => (
            <span
                className={`ps-testimonial-card__star ${index < filled ? 'ps-testimonial-card__star--active' : ''}`}
                key={`star-${index}`}
                aria-hidden="true"
            >
                ★
            </span>
        ));
    }

    render() {
        const pages = this.getReviewPages(this.props.banner);

        if (pages.length === 0) {
            return (
                <section className="ps-home-testimonials" aria-labelledby="customer-testimonials-title">
                    <div className="container-fluid px-0">
                        <div className="ps-home-testimonials__header">
                            <div className="ps-home-testimonials__headingRow">
                                <img
                                    className="ps-home-testimonials__leaf ps-home-testimonials__leaf--left"
                                    src="/assets/img/leaf-2.png"
                                    alt=""
                                    aria-hidden="true"
                                />
                                <h2 className="ps-home-testimonials__title" id="customer-testimonials-title">
                                    What Our Customers Say
                                </h2>
                                <img
                                    className="ps-home-testimonials__leaf ps-home-testimonials__leaf--right"
                                    src="/assets/img/leaf-2.png"
                                    alt=""
                                    aria-hidden="true"
                                />
                            </div>
                        </div>
                    </div>
                </section>
            );
        }

        return (
            <section className="ps-home-testimonials" aria-labelledby="customer-testimonials-title">
                <div className="container-fluid px-0">
                    <div className="ps-home-testimonials__header">
                        <div className="ps-home-testimonials__headingRow">
                            <img
                                className="ps-home-testimonials__leaf ps-home-testimonials__leaf--left"
                                src="/assets/img/leaf-2.png"
                                alt=""
                                aria-hidden="true"
                            />
                            <h2 className="ps-home-testimonials__title" id="customer-testimonials-title">
                                What Our Customers Say
                            </h2>
                            <img
                                className="ps-home-testimonials__leaf ps-home-testimonials__leaf--right"
                                src="/assets/img/leaf-2.png"
                                alt=""
                                aria-hidden="true"
                            />
                        </div>
                    </div>

                    <div className="ps-home-testimonials__carousel">
                        <button
                            type="button"
                            className="ps-home-testimonials__nav ps-home-testimonials__nav--prev"
                            onClick={this.goToPrev}
                            aria-label="Previous testimonials"
                        >
                            <i className="fa fa-angle-left" />
                        </button>

                        <div className="ps-home-testimonials__viewport">
                            <div
                                className="ps-home-testimonials__track"
                                style={{transform: `translateX(-${this.state.activePage * 100}%)`}}
                            >
                                {pages.map((page, pageIndex) => (
                                    <div className="ps-home-testimonials__page" key={`page-${pageIndex}`}>
                                        {page.map((review) => (
                                            <article className="ps-home-testimonials__card" key={review.id}>
                                                <div className="ps-testimonial-card__visual">
                                                    <img
                                                        className="ps-testimonial-card__image"
                                                        src={review.avatar}
                                                        alt={review.name}
                                                        loading="lazy"
                                                    />
                                                </div>

                                                <div className="ps-testimonial-card__content">
                                                    <div className="ps-testimonial-card__stars" aria-label={`${review.rating} out of 5 stars`}>
                                                        {this.renderStars(review.rating)}
                                                    </div>
                                                    <p className="ps-testimonial-card__quote">“{review.text}”</p>
                                                    <p className="ps-testimonial-card__author">- {review.name}</p>
                                                    {review.role ? <p className="ps-testimonial-card__role">{review.role}</p> : null}
                                                </div>
                                            </article>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <button
                            type="button"
                            className="ps-home-testimonials__nav ps-home-testimonials__nav--next"
                            onClick={this.goToNext}
                            aria-label="Next testimonials"
                        >
                            <i className="fa fa-angle-right" />
                        </button>
                    </div>

                    <div className="ps-home-testimonials__dots" role="tablist" aria-label="Testimonials navigation">
                        {pages.map((page, index) => (
                            <button
                                type="button"
                                key={`dot-${index}`}
                                className={`ps-home-testimonials__dot ${this.state.activePage === index ? 'ps-home-testimonials__dot--active' : ''}`}
                                onClick={() => this.setActivePage(index)}
                                aria-label={`Show testimonials page ${index + 1}`}
                                aria-pressed={this.state.activePage === index}
                            />
                        ))}
                    </div>
                </div>
            </section>
        );
    }
}

export default Testimonial;
